'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _basePopupManager = require('@bibliocommons/base-popup-manager');

var _basePopupManager2 = _interopRequireDefault(_basePopupManager);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseDropdown = require('@bibliocommons/base-dropdown');

var _utilsLink = require('@bibliocommons/utils-link');

var _reactIntl = require('react-intl');

var _availabilityStatus = require('@bibliocommons/availability-status');

var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);

var _holdCounts = require('@bibliocommons/hold-counts');

var _holdCounts2 = _interopRequireDefault(_holdCounts);

var _analyticsEventComposers = require('@bibliocommons/analytics-event-composers');

var _FormatIcon = require('./FormatIcon');

var _FormatIcon2 = _interopRequireDefault(_FormatIcon);

var _AvailabilityIcon = require('./AvailabilityIcon');

var _AvailabilityIcon2 = _interopRequireDefault(_AvailabilityIcon);

require('../styles/AdditionalItemFormatsPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeFormatPickerSelectionEvent = _analyticsEventComposers.bibFormatChooser.composeFormatPickerSelectionEvent,
    composeFormatPickerExpandEvent = _analyticsEventComposers.bibFormatChooser.composeFormatPickerExpandEvent;

var AdditionalItemFormatsPopup = function (_BcReactComponent) {
  _inherits(AdditionalItemFormatsPopup, _BcReactComponent);

  function AdditionalItemFormatsPopup(props) {
    _classCallCheck(this, AdditionalItemFormatsPopup);

    var _this = _possibleConstructorReturn(this, (AdditionalItemFormatsPopup.__proto__ || Object.getPrototypeOf(AdditionalItemFormatsPopup)).call(this, props));

    _this.bindAll('renderTrigger', 'renderMenuItems', 'renderPopup');
    return _this;
  }

  _createClass(AdditionalItemFormatsPopup, [{
    key: 'renderTrigger',
    value: function renderTrigger(popupActions, expanded) {
      var _this2 = this;

      var clickHandler = function clickHandler() {
        _this2.props.handleGTMEvent(composeFormatPickerExpandEvent(!expanded));
        popupActions.toggleContent();
      };

      return _react2.default.createElement(
        _baseButtons.PrimaryGhostButton,
        { 'aria-haspopup': 'true', 'aria-expanded': expanded, handleClick: clickHandler },
        _react2.default.createElement(
          'span',
          { className: 'hidden-lg hidden-md' },
          '+',
          this.props.groups.length
        ),
        _react2.default.createElement(
          'span',
          { className: 'visible-lg visible-md' },
          '+',
          this.props.groups.length - 1
        )
      );
    }
  }, {
    key: 'renderMenuItems',
    value: function renderMenuItems(group, index) {
      var _this3 = this;

      // eslint-disable-line
      var item = group.get('item');
      var menuItemClasses = 'additional-format-option ' + (index === 0 ? 'hidden-lg hidden-md' : '');

      var clickHandler = function clickHandler() {
        _this3.props.handleGTMEvent(composeFormatPickerSelectionEvent(item.getIn(['briefInfo', 'format'])));
      };

      return _react2.default.createElement(
        _baseDropdown.DropdownMenuItem,
        { className: menuItemClasses, key: index, 'data-key': 'additional-format-option' },
        _react2.default.createElement(
          'a',
          { onClick: clickHandler, href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(group.get('metadataId')) },
          _react2.default.createElement(
            'div',
            { className: 'bib-brief-info' },
            _react2.default.createElement(_FormatIcon2.default, { format: item.getIn(['briefInfo', 'format']), width: 16, height: 16 }),
            _react2.default.createElement(
              _reactIntl.FormattedMessage,
              { id: 'FORMAT.' + item.getIn(['briefInfo', 'format']).toLowerCase() },
              function (message) {
                return _react2.default.createElement(
                  'div',
                  { className: 'format-publication-date' },
                  message,
                  item.getIn(['briefInfo', 'publicationDate']) && ' - ' + item.getIn(['briefInfo', 'publicationDate'])
                );
              }
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'additional-info' },
            _react2.default.createElement(_AvailabilityIcon2.default, { status: item.getIn(['availability', 'status']), width: 12, height: 12 }),
            _react2.default.createElement(_availabilityStatus2.default, {
              rollUpStatus: item.getIn(['availability', 'status']),
              status: item.getIn(['availability', 'localisedStatus']),
              availabilityLocationType: item.getIn(['availability', 'availabilityLocationType']) }),
            _react2.default.createElement(_holdCounts2.default, {
              tagElement: 'div',
              localeKey: 'holdCountAlt',
              heldCopies: item.getIn(['availability', 'heldCopies']),
              availableCopies: item.getIn(['availability', 'availableCopies']),
              totalCopies: item.getIn(['availability', 'totalCopies']) }),
            _react2.default.createElement(
              _reactIntl.FormattedMessage,
              { id: 'edition_count', values: { count: group.get('size') } },
              function (message) {
                return group.get('size') >= 1 ? _react2.default.createElement(
                  'div',
                  { className: 'group-size' },
                  message
                ) : null;
              }
            )
          )
        )
      );
    }
  }, {
    key: 'renderPopup',
    value: function renderPopup(popupActions) {
      return _react2.default.createElement(
        _baseDropdown.DropdownMenu,
        { closeAndFocus: popupActions.closeAndFocusContent, right: true },
        this.props.groups.map(this.renderMenuItems)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _basePopupManager2.default,
        { renderContent: this.renderPopup, className: 'cp-additional-item-formats-popup', closeOnClick: true },
        this.renderTrigger
      );
    }
  }]);

  return AdditionalItemFormatsPopup;
}(_baseBcReactComponent2.default);

AdditionalItemFormatsPopup.displayName = 'AdditionalItemFormatsPopup';
AdditionalItemFormatsPopup.propTypes = {
  groups: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
  handleGTMEvent: _react.PropTypes.func
};

AdditionalItemFormatsPopup.defaultProps = {
  handleGTMEvent: function handleGTMEvent() {},
  groups: []
};

exports.default = AdditionalItemFormatsPopup;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/components/AdditionalItemFormatsPopup.component.js
// module id = 872
// module chunks = 9 10